var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('weui-group',{attrs:{"type":"radio","notitle":_vm.notitle,"title":_vm.title,"tips":_vm.tips}},_vm._l((_vm.options2),function(opt){return _c('weui-radiobox',_vm._b({key:opt.value,attrs:{"name":_vm.group},on:{"change":function($event){_vm.fireChange(opt.value)}}},'weui-radiobox',opt,false))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24fa4459","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weui/radio-group/Index.vue
// module id = null
// module chunks = 